
export const SSAP_FLOW_VERSION = 2;
export const ENABLED = 'Enabled';
export const DISABLED = 'Disabled';

export const UNEMPLOYMENT_INCOME_ATTESTATION_SUPPORTED_YEARS = [ 2021 ];

export const SSAP_DATE_FORMATS = {
    HRA_START_DATE: 'HRA_START_DATE'
};

export const USPS_GENERAL_DELIVERY_ADDRESS = 'General Delivery';

export const SSAP_JSON_PROP_NAMES = {
    COUNTY_CODE: 'countyCode',
    EMAIL_ADDRESS: 'emailAddress',
    EMAIL_ME: 'emailMe',
    HOME_ADDRESS: 'homeAddress',
    LIVING_ARRANGEMENT: 'livingArrangement',
    MAILING_ADDRESS: 'mailingAddress',
    NO_HOME_ADDRESS: 'noHomeAddressIndicator',
    OUT_OF_STATE_ATTESTATION: 'outOfStateAttestation',
    PHONE: 'phone',
    PHONE_NUMBER: 'phoneNumber',
    STATE: 'state',
    STREET_ADDRESS_1: 'streetAddress1',
    TEXT_ME: 'textMe',
    EMERGENCY_CONTACT_INFO : 'emergencyContactInfo'
};

export const PHONE_TYPES = {
    HOME: 'HOME',
    MOBILE: 'MOBILE'
};
export const GENDER_TYPES = {
    MALE: 'male',
    FEMALE: 'female'
};

export const INLINE_ELIGIBILITY_VALUES = {
    YES: 'YES',
    NO: 'NO', // for unit tests, it might not exist
    NOT_APPLICABLE: 'NA'
};

export const INCOME_SOURCES_SUMMARY_GROUPING = [
    [
        'ssap.input.option.job',
        'ssap.input.option.pension',
        'ssap.input.option.rental_royalty',
        'ssap.input.option.alimony',
        'ssap.input.option.scholarship'
    ],
    [
        'ssap.input.option.self_employment',
        'ssap.input.option.ss_benefits',
        'ssap.input.option.farming_fishing',
        'ssap.input.option.investment'
    ],
    [
        'ssap.input.option.retirement',
        'ssap.input.option.capital_gains',
        'ssap.input.option.unemployment',
        'ssap.input.option.other_income'
    ]
];